import { cat } from './pets/cat';
import { octo } from './pets/octo';
import { pup } from './pets/pup';
import { bunny } from './pets/bunny';
import { chick } from './pets/chick';
import { frog } from './pets/frog';
import { hamster } from './pets/hamster';
import { fox } from './pets/fox';
import { owl } from './pets/owl';
import { bee } from './pets/bee';
import { axolotl } from './pets/axolotl';
import { sheep } from './pets/sheep';
import { dino } from './pets/dino';
import { crab } from './pets/crab';
import { whale } from './pets/whale';
import { caterpillar } from './pets/caterpillar';

/** Pets bodies, in picker order. */
export const PETS_BODIES = {
  cat,
  octo,
  pup,
  bunny,
  chick,
  frog,
  hamster,
  fox,
  owl,
  bee,
  axolotl,
  sheep,
  dino,
  crab,
  whale,
  caterpillar,
};
